export enum DatepickerStartView {
  MONTH = 'month',
  YEAR = 'year',
  MULTI_YEAR = 'multi-year',
}
